// @flow

import type { EasyAction } from '../../type'

import * as React from 'react'

type Props = {
  convertId: string
};

export default class Inmobi extends React.PureComponent<Props> {
  static actions: EasyAction[] = [
    {
      title: '记录点击事件',
      name: 'pushEvent'
    }
  ];

  componentWillMount () {
    loadAdCode()
  }

  actionPushEvent = (data: void) => {
    fireEvent('download', 'download')
  };

  render () {
    return null
  }
}

function fireEvent (eventType, eventName) {
  console.log(eventType, eventName)
  var PROPERTY_ID = 'd0eb6a3b538b46cbb12ea514533394b4'
  var PING_SERVER_URL =
    'https://advertiser.inmobiapis.cn/tpce/v1/events/' +
    eventType +
    '?trackingPartner=InMobi&country=CN'
  var pageData = {}
  if (typeof window.InmobiPixel !== 'undefined') {
    window.inmobiPixel = new window.InmobiPixel()
    window.inmobiPixel.init({
      pingServer: PING_SERVER_URL,
      propertyId: PROPERTY_ID,
      domain: 'fengjr.com'
    })
  }
  window.inmobiPixel.ping(eventName, pageData)
}

function fireCustomEvent (eventName) {
  fireEvent('custom', eventName)
}

function loadAdCode () {
  /* eslint-disable */
  var ta = document.createElement('script');
  ta.type = 'text/javascript';
  ta.async = true;
  ta.src = 'https://i.l.inmobicdn.cn/ifctpads/IFC/pixel/inmobipixel.js';
  ta.onload = function() {
    fireCustomEvent('fengjr_lp');
  };
  var s = document.getElementsByTagName('script')[0];
  // $FlowFixMe
  s.parentNode.insertBefore(ta, s);
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/Inmobi.js